<template>
  <div
    class="component-wrapper d-flex flex-column align-center justify-center pa-4"
  >
    <div v-if="loader" style="width: 80%">
      <v-skeleton-loader
        v-for="(n, i) in 3"
        :key="i"
        v-bind="attrs"
        type="image,paragraph"
        :loading="loader"
      ></v-skeleton-loader>
    </div>
    <div
      v-else-if="!loader"
      v-for="(event, i) in events"
      :key="i"
      class="d-flex flex-column mb-4"
      style="width: 100%"
    >
      <div
        @click="onEventSelect(event)"
        class="d-flex justify-center align-center route font-weight-thin body-1 mb-2"
      >
        <v-card width="85vw" style="border-radius: 15px">
          <v-img
            width="100%"
            height="150px"
            :src="'https://villages.e-naxios.com/' + event.main_photo"
          ></v-img>

          <div
            class="secondary--text body-2 font-weigth-regular category ml-6 pt-2"
            style="font-size: 12px"
            v-if="event.event_type"
          >
            {{ event.event_type }}
          </div>
          <div class="secondary--text body-1 font-weight-bold ml-6 pb-2">
            {{ event.title }}
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  async created() {
    try {
      await this.getEvents();
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      events: [],
      loader: false,
    };
  },

  methods: {
    ...mapMutations(["setCurrentEvent"]),

    async getEvents() {
      const res = await axios.get(
        `https://villages.e-naxios.com/api/ekdiloseis?_format=json`
      );
      this.events = res.data;
    },

    onEventSelect(event) {
      const id = event.url.split("/")[5];
      this.setCurrentEvent(event);
      this.$router.push(`${this.$route.path}/${id}`);
    },
  },
};
</script>

<style scoped lang="scss">
.category::before {
  content: "";
  position: absolute;
  left: 0;
  margin-top: 8px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;

  width: 12px;
  height: 5px;
  background: var(--v-accent-base);
}
</style>